/**
 * Info icon on APO pill/choice-tile options opens a modal with metafield data.
 * Data comes from window.MW_POPUP_JSON (product.metafields.custom.popup_json),
 * keyed by Shopify variant id (matches [data-mw-addon-variant-id]).
 *
 * Icons inject after mws_apo_helper dispatches `mws:apo:values-ready`.
 *
 * Sirv follows the Hulkapps pattern:
 * 1) validate folder URL exists (HTML listing with <tr>)
 * 2) mount viewer with left thumbs on desktop (bottom on mobile)
 * 3) Sirv.start() after the modal is open
 * 4) hide the image wrapper if nothing renders
 */
(function () {
  'use strict';

  var MODAL_ID = 'mw-apo-popup';
  var INFO_CLASS = 'mw-apo-popup-info';
  var REQUIRED_OPTIONS_WARNING_BG = '#F9DCA4';
  // Square main slide; thumbs left on desktop, bottom on mobile.
  var SIRV_OPTIONS =
    'thumbnails.position:left;thumbnails.align:start;layout.aspectRatio:1/1;';
  var SIRV_BREAKPOINTS =
    '[{"match":"(max-width: 749.98px)","options":{"thumbnails":{"position":"bottom","align":"center"}}}]';
  var INFO_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="14" height="14" aria-hidden="true" focusable="false">' +
    '<circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
    '<circle cx="10" cy="6.25" r="1.1" fill="currentColor"/>' +
    '<path d="M10 9.1v5.2" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  var modalEl;
  var injectScheduled = false;
  var activeSirvSelector = null;
  var activeSirvToken = 0;
  var sirvFolderCache = {};
  var closeTimer = null;
  var ANIM_MS = 320;

  function getDesktopLayout() {
    var layout = String(window.MW_APO_POPUP_DESKTOP_LAYOUT || 'left').toLowerCase();
    if (layout === 'bottom' || layout === 'center') return layout;
    return 'left';
  }

  function injectStyles() {
    var style = document.getElementById('mw-apo-popup-styles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'mw-apo-popup-styles';
      document.head.appendChild(style);
    }
    style.textContent = [
      /* Shell */
      '.mw-apo-popup{position:fixed;inset:0;z-index:99999;display:none;padding:0;}',
      '.mw-apo-popup.is-visible{display:flex;}',
      '.mw-apo-popup__backdrop{position:absolute;inset:0;background:rgba(15,23,42,.45);opacity:0;transition:opacity .28s ease;}',
      '.mw-apo-popup.is-open .mw-apo-popup__backdrop{opacity:1;}',

      /* Mobile: bottom sheet (all layouts) — image above text */
      '.mw-apo-popup{align-items:flex-end;justify-content:stretch;}',
      '.mw-apo-popup__dialog{position:relative;width:100%;max-width:none;max-height:90vh;margin:0;background:#fff;border-radius:16px 16px 0 0;box-shadow:0 -8px 40px rgba(15,23,42,.2);overflow:auto;-webkit-overflow-scrolling:touch;transform:translate3d(0,100%,0);opacity:1;transition:transform .32s cubic-bezier(.22,1,.36,1),opacity .32s ease;}',
      '.mw-apo-popup.is-open .mw-apo-popup__dialog{transform:translate3d(0,0,0);opacity:1;}',
      '.mw-apo-popup__dialog--has-sirv{max-width:none;}',

      /* Desktop layouts */
      '@media (min-width:750px){',
      '.mw-apo-popup__backdrop{background:rgba(15,23,42,.28);backdrop-filter:none;-webkit-backdrop-filter:none;}',

      /* 1) Left drawer */
      '.mw-apo-popup--desktop-left{align-items:stretch;justify-content:flex-start;}',
      '.mw-apo-popup--desktop-left .mw-apo-popup__dialog{width:40vw;max-width:40vw;height:100%;max-height:100vh;border-radius:0 16px 16px 0;box-shadow:8px 0 40px rgba(15,23,42,.18);transform:translate3d(-100%,0,0);}',
      '.mw-apo-popup--desktop-left.is-open .mw-apo-popup__dialog{transform:translate3d(0,0,0);}',
      '.mw-apo-popup--desktop-left .mw-apo-popup__dialog--has-sirv{max-width:40vw;}',

      /* 2) Bottom sheet */
      '.mw-apo-popup--desktop-bottom{align-items:flex-end;justify-content:stretch;}',
      '.mw-apo-popup--desktop-bottom .mw-apo-popup__dialog{width:100%;max-width:none;height:60vh;max-height:60vh;border-radius:16px 16px 0 0;box-shadow:0 -8px 40px rgba(15,23,42,.2);transform:translate3d(0,100%,0);display:flex;flex-direction:column;align-items:center;}',
      '.mw-apo-popup--desktop-bottom.is-open .mw-apo-popup__dialog{transform:translate3d(0,0,0);}',
      '.mw-apo-popup--desktop-bottom .mw-apo-popup__dialog--has-sirv{max-width:none;}',
      '.mw-apo-popup--desktop-bottom .mw-apo-popup__header,.mw-apo-popup--desktop-bottom .mw-apo-popup__body{width:100%;max-width:1080px;box-sizing:border-box;}',

      /* 3) Centered modal */
      '.mw-apo-popup--desktop-center{align-items:center;justify-content:center;padding:24px;}',
      '.mw-apo-popup--desktop-center .mw-apo-popup__backdrop{background:rgba(15,23,42,.4);}',
      '.mw-apo-popup--desktop-center .mw-apo-popup__dialog{width:min(920px,92vw);max-width:min(920px,92vw);height:auto;max-height:min(80vh,720px);border-radius:16px;box-shadow:0 24px 64px rgba(15,23,42,.28);transform:translate3d(0,16px,0) scale(.98);opacity:0;}',
      '.mw-apo-popup--desktop-center.is-open .mw-apo-popup__dialog{transform:translate3d(0,0,0) scale(1);opacity:1;}',
      '.mw-apo-popup--desktop-center .mw-apo-popup__dialog--has-sirv{max-width:min(920px,92vw);}',
      '}',

      '.mw-apo-popup__header{display:flex;align-items:flex-start;gap:12px;padding:16px 16px 12px 20px;position:sticky;top:0;background:#fff;z-index:2;}',
      '.mw-apo-popup__heading{flex:1;min-width:0;padding-right:8px;}',
      '.mw-apo-popup__option{margin:0 0 4px;font-size:14px;line-height:1.3;font-weight:600;color:#64748b;}',
      '.mw-apo-popup__option:empty{display:none;}',
      '.mw-apo-popup__title{margin:0;font-size:22px;line-height:1.25;font-weight:700;color:#0f172a;}',
      '.mw-apo-popup__close{flex:0 0 auto;display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;margin:0;padding:0;border:0;border-radius:10px;background:#f2f2f2;color:#111;font-size:28px;line-height:1;font-weight:400;cursor:pointer;transition:background .15s ease,color .15s ease;}',
      '.mw-apo-popup__close:hover{background:#e8e8e8;color:#000;}',
      '.mw-apo-popup__close:focus-visible{outline:2px solid #94a3b8;outline-offset:2px;}',
      '.mw-apo-popup__body{padding:0 20px 24px;}',
      '.mw-apo-popup__content{min-width:0;}',
      /* Mobile: full width. Desktop: 70% left-aligned. */
      '.mw-apo-popup__sirv{margin:0 0 16px;width:100%;min-height:240px;}',
      '@media (min-width:750px){.mw-apo-popup__sirv{width:70%;}}',
      '.mw-apo-popup__sirv .Sirv,.mw-apo-popup__sirv .hulk_fetched_image{display:block;width:100%;}',
      '.mw-apo-popup__sirv .smv-slides-box{aspect-ratio:1/1;width:100%;}',
      '.mw-apo-popup__sirv .smv-slides-box .smv-slide img{object-fit:contain;}',
      '.mw-apo-popup__price{margin:0 0 10px;font-size:20px;font-weight:700;color:#0f172a;}',
      '.mw-apo-popup__short-description{margin:0 0 16px;font-size:18px;line-height:1.5;color:#334155;word-break:break-word;}',
      '.mw-apo-popup__warning{margin:0 0 4px;padding:12px 14px;border-radius:8px;background:' + REQUIRED_OPTIONS_WARNING_BG + ';font-size:18px;line-height:1.5;color:#5c4413;}',
      '.mw-apo-popup__warning strong{font-weight:700;}',
      '.mw-apo-popup__empty{margin:0;font-size:14px;color:#64748b;}',
      '.mw-option__value--has-popup{position:relative;}',
      '.mw-option__value--has-popup .mw-option__button{padding-right:22px;padding-bottom:18px;}',
      '.mw-option__value--has-popup .mw-stack--card{padding-right:8px;padding-bottom:22px;}',
      '.' + INFO_CLASS + '{position:absolute;right:2px;bottom:2px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;padding:6px;border:0px;border-radius:6px;color:#334155;cursor:pointer;line-height:0;transition:background .15s ease,color .15s ease;}',
      '.' + INFO_CLASS + ':hover,' +
      '.' + INFO_CLASS + ':focus-visible{background:rgba(15,23,42,.16);color:#0f172a;outline:none;border-radius:6px;}',
      '.' + INFO_CLASS + ' svg{display:block;}'
    ].join('');
  }

  function buildModal() {
    if (modalEl) return modalEl;
    injectStyles();

    modalEl = document.createElement('div');
    modalEl.className = 'mw-apo-popup mw-apo-popup--desktop-' + getDesktopLayout();
    modalEl.id = MODAL_ID;
    modalEl.setAttribute('role', 'dialog');
    modalEl.setAttribute('aria-modal', 'true');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML =
      '<div class="mw-apo-popup__backdrop" data-mw-popup-close></div>' +
      '<div class="mw-apo-popup__dialog">' +
      '  <div class="mw-apo-popup__header">' +
      '    <div class="mw-apo-popup__heading">' +
      '      <p class="mw-apo-popup__option"></p>' +
      '      <h2 class="mw-apo-popup__title"></h2>' +
      '    </div>' +
      '    <button type="button" class="mw-apo-popup__close" aria-label="Close" data-mw-popup-close>&times;</button>' +
      '  </div>' +
      '  <div class="mw-apo-popup__body"></div>' +
      '</div>';

    document.body.appendChild(modalEl);

    modalEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-mw-popup-close]')) close();
    });

    return modalEl;
  }

  function getSirvBrand(data) {
    return (data && data.sirvBrand) || window.MW_SIRV_BRAND || '';
  }

  function folderUrlFor(brand, sku) {
    if (!brand || !sku || String(brand) === 'null' || String(sku) === 'null') return '';
    var queryRoot = 'https://especialneeds.sirv.com/products/';
    var queryURL = queryRoot + String(brand).trim() + '/' + String(sku).trim();
    if (queryURL.slice(-1) === '/') queryURL = queryURL.slice(0, -1);
    return queryURL;
  }

  /**
   * Hulkapps-style folder check: fetch the Sirv products folder and treat
   * a directory listing (HTML containing <tr>) as a valid media source.
   */
  function isValidSource(brand, sku) {
    var queryURL = folderUrlFor(brand, sku);
    if (!queryURL) return Promise.resolve(null);

    if (Object.prototype.hasOwnProperty.call(sirvFolderCache, queryURL)) {
      return Promise.resolve(sirvFolderCache[queryURL]);
    }

    return fetch(queryURL, { method: 'GET', mode: 'cors', credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) {
          sirvFolderCache[queryURL] = null;
          return null;
        }

        var contentType = response.headers.get('Content-Type') || '';
        if (contentType.indexOf('text/html') === -1) {
          sirvFolderCache[queryURL] = null;
          return null;
        }

        return response.text().then(function (html) {
          var valid = html.indexOf('<tr>') !== -1 ? queryURL : null;
          sirvFolderCache[queryURL] = valid;
          return valid;
        });
      })
      .catch(function () {
        sirvFolderCache[queryURL] = null;
        return null;
      });
  }

  function uniqueSirvId() {
    return (
      'smv-modal-' +
      Date.now() +
      '-' +
      Math.random().toString(36).substr(2, 9)
    );
  }

  function stopSirv() {
    if (!activeSirvSelector || typeof window.Sirv === 'undefined') {
      activeSirvSelector = null;
      return;
    }
    try {
      if (typeof window.Sirv.stop === 'function') {
        window.Sirv.stop(activeSirvSelector);
      }
    } catch (err) {
      /* ignore */
    }
    activeSirvSelector = null;
  }

  function waitForSirv(maxAttempts) {
    maxAttempts = maxAttempts || 20;
    return new Promise(function (resolve) {
      var attempt = 0;
      function tick() {
        if (typeof window.Sirv !== 'undefined' && typeof window.Sirv.start === 'function') {
          resolve(true);
          return;
        }
        attempt += 1;
        if (attempt >= maxAttempts) {
          resolve(false);
          return;
        }
        setTimeout(tick, 100);
      }
      tick();
    });
  }

  function buildSirvElement(viewSrc) {
    var wrap = document.createElement('div');
    wrap.className = 'mw-apo-popup__sirv';

    var id = uniqueSirvId();
    // Match Hulkapps markup exactly (string insert, same options/attrs).
    wrap.innerHTML =
      '<div data-options="' +
      SIRV_OPTIONS +
      '" data-breakpoints=\'' +
      SIRV_BREAKPOINTS +
      '\' class="Sirv hulk_fetched_image" id="' +
      id +
      '" data-src="' +
      escapeHtml(viewSrc) +
      '" role="region" aria-label="Popup Image" aria-roledescription="carousel"></div>';

    return { wrap: wrap, id: id, viewer: wrap.firstElementChild };
  }

  function popupIsActive() {
    return !!(modalEl && modalEl.classList.contains('is-visible'));
  }

  function whenDialogSettled(callback) {
    if (!modalEl) return;
    var dialog = modalEl.querySelector('.mw-apo-popup__dialog');
    if (!dialog) {
      callback();
      return;
    }

    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      dialog.removeEventListener('transitionend', onEnd);
      callback();
    }
    function onEnd(e) {
      if (e.target === dialog && e.propertyName === 'transform') finish();
    }

    dialog.addEventListener('transitionend', onEnd);
    // Fallback if transitionend doesn't fire (reduced motion / already open).
    setTimeout(finish, ANIM_MS + 80);
  }

  function hideSirvIfEmpty(token) {
    setTimeout(function () {
      if (token !== activeSirvToken || !popupIsActive()) return;

      var wrap = modalEl.querySelector('.mw-apo-popup__sirv');
      var viewer = wrap && wrap.querySelector('.hulk_fetched_image, .Sirv');
      if (!wrap || !viewer) return;

      var hasContent =
        viewer.querySelector(
          'img[src], iframe[src], canvas, svg, .sirv-viewer, .sirv-spin, .smv-slide, .smv-selectors'
        ) != null;
      var hasDimensions = viewer.offsetWidth > 50 && viewer.offsetHeight > 50;

      if (!hasContent && !hasDimensions) {
        stopSirv();
        wrap.remove();
        var dialog = modalEl.querySelector('.mw-apo-popup__dialog');
        if (dialog) dialog.classList.remove('mw-apo-popup__dialog--has-sirv');
      }
    }, 2500);
  }

  function startSirvViewer(built, token) {
    if (token !== activeSirvToken || !popupIsActive()) return;

    void built.viewer.offsetWidth;
    void built.viewer.offsetHeight;

    try {
      window.Sirv.start('#' + built.id);
      activeSirvSelector = '#' + built.id;
    } catch (err) {
      try {
        window.Sirv.start();
        activeSirvSelector = '#' + built.id;
      } catch (err2) {
        /* ignore */
      }
    }
    hideSirvIfEmpty(token);
  }

  function mountAndStartSirv(folderUrl, token) {
    if (token !== activeSirvToken || !popupIsActive()) return;

    var body = modalEl.querySelector('.mw-apo-popup__body');
    var dialog = modalEl.querySelector('.mw-apo-popup__dialog');
    if (!body || !dialog) return;

    stopSirv();

    var existing = body.querySelector('.mw-apo-popup__sirv');
    if (existing) existing.remove();

    var built = buildSirvElement(folderUrl + '.view');
    dialog.classList.add('mw-apo-popup__dialog--has-sirv');

    var content = body.querySelector('.mw-apo-popup__content');
    if (content) {
      body.insertBefore(built.wrap, content);
    } else {
      body.insertBefore(built.wrap, body.firstChild);
    }

    waitForSirv().then(function (ready) {
      if (!ready || token !== activeSirvToken || !popupIsActive()) return;

      // Wait until the sheet/drawer finishes sliding so Sirv can measure layout.
      whenDialogSettled(function () {
        if (token !== activeSirvToken || !popupIsActive()) return;
        // One more frame after settle for final box size.
        requestAnimationFrame(function () {
          startSirvViewer(built, token);
        });
      });
    });
  }

  function maybeMountSirv(data, token) {
    var brand = getSirvBrand(data);
    var sku = data && data.sku;
    if (!brand || !sku) return;

    isValidSource(brand, sku).then(function (folderUrl) {
      if (!folderUrl || token !== activeSirvToken) return;
      mountAndStartSirv(folderUrl, token);
    });
  }

  function hasText(value) {
    return value != null && String(value).trim() !== '';
  }

  function formatPrice(price) {
    if (price == null || price === '') return '';
    var num = parseFloat(String(price).replace(/[^0-9.\-]/g, ''));
    if (isNaN(num)) return '$' + String(price);
    // Free / zero-dollar options: omit the price entirely.
    if (num === 0) return '';
    return '$' + num.toFixed(2);
  }

  function getOptionSku(data, valueEl) {
    if (data && hasText(data.sku) && String(data.sku) !== 'null') {
      return String(data.sku).trim();
    }
    var fromEl = valueEl && valueEl.getAttribute('data-mw-sku');
    if (hasText(fromEl) && String(fromEl) !== 'null') return String(fromEl).trim();
    return '';
  }

  function hasSirvMedia(data, valueEl) {
    var brand = getSirvBrand(data);
    var sku = getOptionSku(data, valueEl);
    return hasText(brand) && String(brand) !== 'null' && hasText(sku);
  }

  function hasPopupDetails(data, valueEl) {
    if (data) {
      if (hasText(data.shortDescription)) return true;
      if (hasText(data.disclaimer)) return true;
    }
    return hasSirvMedia(data, valueEl);
  }

  function buildFieldsHtml(variantId, data) {
    var parts = [];

    var price = formatPrice(data.price);
    if (price) {
      parts.push('<p class="mw-apo-popup__price">' + escapeHtml(price) + '</p>');
    }

    if (hasText(data.shortDescription)) {
      parts.push(
        '<p class="mw-apo-popup__short-description">' +
          escapeHtml(String(data.shortDescription).trim()) +
          '</p>'
      );
    }

    // Orange box only when disclaimer has text (requiredOptions is not shown).
    if (hasText(data.disclaimer)) {
      parts.push(
        '<div class="mw-apo-popup__warning">' +
          escapeHtml(String(data.disclaimer).trim()) +
          '</div>'
      );
    }

    return parts.join('');
  }

  function renderBody(variantId, data) {
    var body = modalEl.querySelector('.mw-apo-popup__body');
    var dialog = modalEl.querySelector('.mw-apo-popup__dialog');
    var fieldsHtml = buildFieldsHtml(variantId, data);
    var contentHtml = fieldsHtml || '<p class="mw-apo-popup__empty">No additional details.</p>';

    stopSirv();
    dialog.classList.remove('mw-apo-popup__dialog--has-sirv');

    // Image above; price/description/etc. stack below.
    body.classList.remove('mw-apo-popup__body--grid');
    body.innerHTML = '<div class="mw-apo-popup__content">' + contentHtml + '</div>';
  }

  function formatOptionLabel(option) {
    if (!hasText(option)) return '';
    return String(option)
      .replace(/\s*\(Required\)/gi, ' *')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function setPopupHeading(data) {
    var optionEl = modalEl.querySelector('.mw-apo-popup__option');
    var titleEl = modalEl.querySelector('.mw-apo-popup__title');
    var optionLabel = formatOptionLabel(data && data.option);
    var title = hasText(data && data.title) ? String(data.title).trim() : 'Selection';

    optionEl.textContent = optionLabel;
    titleEl.textContent = title;
  }

  function open(variantId, data) {
    buildModal();
    activeSirvToken += 1;
    var token = activeSirvToken;

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    modalEl.classList.remove(
      'mw-apo-popup--desktop-left',
      'mw-apo-popup--desktop-bottom',
      'mw-apo-popup--desktop-center'
    );
    modalEl.classList.add('mw-apo-popup--desktop-' + getDesktopLayout());

    setPopupHeading(data);
    renderBody(variantId, data);

    modalEl.classList.add('is-visible');
    modalEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onKeydown);

    // Next frame so the off-screen transform paints before sliding in.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modalEl.classList.add('is-open');
      });
    });

    // Modal is visible first; Sirv mounts only after folder validation.
    maybeMountSirv(data, token);
  }

  function close() {
    if (!modalEl) return;
    activeSirvToken += 1;
    stopSirv();
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);

    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      closeTimer = null;
      if (modalEl && !modalEl.classList.contains('is-open')) {
        modalEl.classList.remove('is-visible');
      }
    }, ANIM_MS);
  }

  function onKeydown(e) {
    if (e.key === 'Escape') close();
  }

  function escapeHtml(str) {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getPopupData(variantId) {
    var lookup = window.MW_POPUP_JSON || {};
    return variantId ? lookup[variantId] || null : null;
  }

  function optionText(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    clone.querySelectorAll('.mws-text__sku, .mw-apo-value-sku').forEach(function (node) {
      node.remove();
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function resolvePopupData(valueEl) {
    var variantId = valueEl && valueEl.dataset.mwAddonVariantId;
    var data = Object.assign({}, getPopupData(variantId) || {});
    var sku = getOptionSku(data, valueEl);
    if (sku) data.sku = sku;

    if (!hasText(data.title)) {
      data.title = optionText(
        valueEl.querySelector('.mw-stack--card__title') ||
          valueEl.querySelector('.mw-option__value-title') ||
          valueEl.querySelector('.mw-text')
      );
    }

    if (!hasText(data.option)) {
      var optionEl = valueEl.closest('.mw-option');
      data.option = optionText(
        optionEl &&
          (optionEl.querySelector('[data-mw-option-title]') ||
            optionEl.querySelector('.mw-option__title') ||
            optionEl.querySelector('.mw-label > .mw-stack .mw-text'))
      );
    }

    return data;
  }

  function openForValueEl(valueEl) {
    if (!valueEl) return;
    var variantId = valueEl.dataset.mwAddonVariantId || '';
    var data = resolvePopupData(valueEl);
    if (!hasPopupDetails(data, valueEl)) return;
    open(variantId, data);
  }

  function createInfoButton(valueEl) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = INFO_CLASS;
    btn.setAttribute('aria-label', 'More information');
    btn.innerHTML = INFO_SVG;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openForValueEl(valueEl);
    });

    return btn;
  }

  function injectInfoIcons() {
    injectStyles();
    var lookup = window.MW_POPUP_JSON || {};
    var hasLookup = !!(lookup && Object.keys(lookup).length);
    var hasSirvBrand = hasText(window.MW_SIRV_BRAND) && String(window.MW_SIRV_BRAND) !== 'null';
    if (!hasLookup && !hasSirvBrand) return;

    document.querySelectorAll('.mw-option__value[data-value-id]').forEach(function (valueEl) {
      var isPillOrTile =
        valueEl.querySelector('.mw-option__button') ||
        valueEl.querySelector('.mw-label__card-wrapper, .mw-stack--card');
      if (!isPillOrTile) return;

      var data = getPopupData(valueEl.dataset.mwAddonVariantId);
      var existing = valueEl.querySelector(':scope > .' + INFO_CLASS);

      // Show the info icon when there is text, a disclaimer, or Sirv brand + SKU.
      if (!hasPopupDetails(data, valueEl)) {
        if (existing) existing.remove();
        valueEl.classList.remove('mw-option__value--has-popup');
        return;
      }

      valueEl.classList.add('mw-option__value--has-popup');
      if (existing) return;

      valueEl.appendChild(createInfoButton(valueEl));
    });
  }

  function scheduleInject() {
    if (injectScheduled) return;
    injectScheduled = true;
    requestAnimationFrame(function () {
      injectScheduled = false;
      injectInfoIcons();
    });
  }

  function onValuesReady() {
    scheduleInject();
  }

  injectStyles();

  document.addEventListener('mws:apo:values-ready', onValuesReady);

  if (window.MWS_APO && window.MWS_APO.valuesReady) {
    onValuesReady();
  }
})();
